// A referral link's code, kept in this browser so a Google/Microsoft sign-up (which skips our form) can carry it through login.
export const REFERRAL_KEY = "scoutm8:referral";
const MAX_AGE_MS = 7 * 86400000;

export function storeReferral(ref) {
  try {
    if (ref) localStorage.setItem(REFERRAL_KEY, JSON.stringify({ ...ref, at: Date.now() }));
    else localStorage.removeItem(REFERRAL_KEY);
  } catch {}
}

// The saved link code, or "" when there is none or it is over a week old.
export function readReferralCode() {
  try {
    const ref = JSON.parse(localStorage.getItem(REFERRAL_KEY) || "null");
    return ref?.code && Date.now() - (ref.at || 0) < MAX_AGE_MS ? String(ref.code) : "";
  } catch {
    return "";
  }
}
